<template>
  <div>
    <div v-for="progressbar in data" :key="progressbar.id" class="my-2">
      <div
        v-if="showDetail"
        class="d-flex align-items-center justify-content-between"
      >
        <span> {{ progressbar.title }}</span>
        <span>{{ progressbar.value }}%</span>
      </div>
      <b-progress
        class="progress"
        :max="progressbar.max"
        :height="progressbar.height"
      >
        <b-progress-bar
          :value="progressbar.value"
          class="progress-bar"
          :style="`background-color:${progressbar.color}`"  
        ></b-progress-bar>
      </b-progress>
    </div>
  </div>
</template>

<script>
export default {
  name: 'custom-bar',
  props: {
    data: {
      type: Array,
    },
    showDetail: {
      type: Boolean,
    },
  },
}
</script>

<style scoped lang='scss'>
@import '../../../design/globalCss.scss';
::v-deep .progress {
  background: #dddddd !important;
}
::v-deep .progress-bar {
  border-radius: 20px !important;
}
span {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0px;
}
</style>